import { Scene, Layer } from 'babylonjs'

export const loadImageLayer = (src: string, scene: Scene): Layer => {
  if (scene.layers) {
    scene.layers = scene.layers?.filter(r => r.name !== 'BackgroudImage')
  }
  scene.environmentTexture = null
  return new Layer('BackgroudImage', src, scene, true)
}
